var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"my-20! text-4xl font-light lg:text-5xl text-center text-secondary-color",class:_vm.className},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }